import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconMegaphone24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="megaphone">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.927 1.88412C19.3001 1.34101 19.9167 1.01648 20.5756 1.01648H22C23.1046 1.01648 24 1.91191 24 3.01648V21.0058C24 22.1049 23.1125 23.0005 22.01 23.0047C21.489 23.0067 20.8742 23.0083 20.4704 23.0067C19.8552 23.0043 19.3143 22.6969 18.9834 22.2125L17.8175 20.5057C17.5413 20.1013 17.1262 19.8123 16.6511 19.6936L8 17.5308V21.0013C8 22.6589 6.65603 24 5 24H4C3.44772 24 3 23.5523 3 23V17H2C0.89543 17 -2.26496e-06 16.1046 0 15L1.21594e-05 9.00002C1.44243e-05 7.89545 0.895445 7.00002 2.00001 7.00002H5.87691L16.6554 4.30538C17.1288 4.18702 17.5426 3.89968 17.8189 3.49745L18.927 1.88412ZM3.99901 15C3.99868 15 3.99934 15 3.99901 15C3.99934 15 4.00066 15 4.00099 15H6L6 9.00002H2.00001L2 15H3.99901ZM5 17V22C5.5531 22 6 21.5527 6 21.0013V17.0308L5.87689 17H5ZM22 3.01648L20.5756 3.01648L19.4674 4.62981C18.9149 5.43427 18.0873 6.00896 17.1405 6.24566L8 8.5308V15.4692L17.1362 17.7533C18.0864 17.9908 18.9165 18.5688 19.469 19.3776L20.5821 21.0071C20.9741 21.008 21.523 21.0066 22 21.0047V3.01648Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
